import { AuthenticatedTemplate } from "@azure/msal-react";
import { NavigationBar } from "./NavigationBar";

export const PageLayout = (props) => {
  return (
    <>
      <NavigationBar />
      <div className="mainContainer">
        {props.children}
        <br />
      </div>
      <footer>
        <center>
          © {new Date().getFullYear()} DOMMICRO LLC all rights reserved. <br />
          <br />
        </center>
      </footer>
      <AuthenticatedTemplate />
    </>
  );
};
